import Header from '../auth/Header';
import Footer from '../auth/Footer';

export default function AuthLayout({ children, px, maxWidth }: { children: React.ReactNode; px?: string, maxWidth?: string }) {
  return (
    <div className="flex w-full min-h-screen flex-col bg-color-a4">
      <Header />
      <div className="flex-1 flex flex-col items-center justify-center py-16">
        <div className={`flex flex-col w-full rounded-xl bg-white mt-4 p-8 ${px} ${maxWidth ? maxWidth : "max-w-lg"}`}>
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
}